export default __webpack_public_path__ + "static/media/usdc.2e84bf35.svg";